import Vuex from 'vuex'
import client from './modules/client'
import events from './modules/events'
import teams from './modules/teams'
import points from './modules/points'

export default new Vuex.Store({
    modules: {
        client,
        events,
        teams,
        points
    },
    strict: process.env.NODE_ENV !== 'production'
});


// WEBPACK FOOTER //
// ./src/store/index.js